import * as v2 from './v2';
export class RegisterEventHandler {
    constructor(provider) {
        this.provider = provider;
        this.listener = (event) => {
            this.handleEvent(v2.RegisterEvent.from(event));
        };
        this.handleEvent = (event) => {
            event.inject(this.providedDependenciesOf(event));
        };
    }
    addEventListener(el) {
        el.addEventListener('register', this.listener);
        return () => el.removeEventListener('register', this.listener);
    }
    providedDependenciesOf({ collectedDependencies, requestedDependencies, targetComponent, target, }) {
        return this.provider.provide(requestedDependencies, {
            collectedDependencies,
            targetComponent,
            targetElement: target || undefined,
        });
    }
}
//# sourceMappingURL=handler.js.map